<ion-content>
  <ion-row class="p-0">
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12" class="p-0 leftSide text-left">
      <div class="rightSideCard">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="fs-24 font_semibold">Welcome to <span class="fs-30 font_bold catalystTextColor">Phi EDGE-HRIS</span></div>
          </ion-col>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10">
            <div class="formLabelRegularfs18 font_semibold">A real-time and intelligent talent management solution. It helps address all people challenges through application of various people modules. We are delighted to be of service to you.
            </div>
          </ion-col>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <div class="fs-20 font_semibold">FOR HR BY HR</div>
          </ion-col>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10 text-center">
            <img src="././assets/icon/loginRightNetwork.png" class="h350">
          </ion-col>
        </ion-row>
      </div>
    </ion-col>
    <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12" class="p-0" class="rightSide">
      <div class="loginCard">
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="text-center">
            <img class="h-80" src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg">
          </ion-col>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-20 text-center">
            <div class="formLabelSemiBoldfs24">SIGN IN</div>
          </ion-col>
        </ion-row>
        <form [formGroup]="loginForm" (ngSubmit)="onClickLogin()">
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10">
              <img src="././assets/icon/emailIcon.svg" class="mailIcon">
              <input type="text" placeholder="Email ID" class="inputstyle font_regular olnone form-control" autocomplete="off" formControlName="email">
            </ion-col>
            <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && loginForm.controls['email'].hasError('required')">
              Email ID is required</label>
              <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && loginForm.controls['email'].hasError('pattern')">
                Please Enter Correct Email ID</label>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="mt-10">
              <img src="././assets/icon/lockIcon.svg" class="mailIcon">
              <input type="{{passwordShow}}" placeholder="Password" class="inputstyle font_regular olnone form-control" autocomplete="off" formControlName="password">
                <img src="././assets/icon/eye-show.png" class="eyeIcon cp" (click)="onEyeClick()" *ngIf="!showpwd">
                <img src="././assets/icon/eye-hide.png" class="eyeIcon cp" (click)="onEyeClick()" *ngIf="showpwd">
            </ion-col>
            <label class="red-cl font_regular fs-12 pl-5" *ngIf="formSubmitted && loginForm.controls['password'].hasError('required')">
              Password is required</label>
          </ion-row>
          <div class="clear20"></div>
        <ion-row>
          <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
            <button type="submit" class="text-center fs-16 font_semibold login-btn">Login</button>
          </ion-col>
        </ion-row>
      </form>
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="6" size-xs="12">
        </ion-col>
        <ion-col size-sm="12" size-md="12" size-lg="6" size-xs="12" class="text-right">
          <label class="fs-16 font_medium cp forgotPassword" (click)="onClickForgotPassword()">Forgot Password?</label>
        </ion-col>
      </ion-row>
      </div>
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="d-flex justify-content-flex-end">
          <div class="bottomPosFixed">
            <div class="pl-10 fs-10 font_regular text_gray">Powered By:</div>
            <img class="powerdByIcon" src="././assets/icon/phiedgeSidebarpoweredbyIcon.jpg">
          </div>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-content>
